import { Injectable } from '@angular/core';
import { PouchdbService } from '../shared/pouchDb.service';
import { Constants } from '../shared/models/constants'
import { BookData } from '../shared/models/bookData';
import { ShelfValues } from '../shared/models/shelfEnums';
import { Page } from '../shared/models/page';
import { Book } from '../shared/models/book';
import { Subject } from 'rxjs';
import { PageContent } from '../shared/models/pageContent';
import { LiquidModel } from '../shared/models/liquidModel';
import { ELEpouchdbService } from '../ELE/ELE.pouchdb.service';
import { Http } from '@angular/http';
import { IS_ElectronService } from '../shared/IS_Electron.service';
var convert = require('xml-js');
import * as _ from "lodash";

@Injectable()
export class donwloadEleService {
    localDB; remoteDB;
    bookDataObj: BookData = new BookData();
    public pageCount = 0
    jsondata;
    constructor(public pouchService: PouchdbService, public elepouchService: ELEpouchdbService, private http: Http, private ElectronService: IS_ElectronService) {
        this.localDB = pouchService.localDB;
    }

    createNewElessonBook(result, pageobj) {

        this.pageCount = 0;
        var bookObj = new Book();
        bookObj.author = Constants.USER;
        bookObj.bookType = 3;
        bookObj.bookCategory = ShelfValues.Creations;
        bookObj.title = result.name;
        bookObj.owner = Constants.USER;
        bookObj.bId = Constants.getGUID();
        bookObj._id = Constants.USER + "." + bookObj.bId + ".book";
        bookObj.coverPage = result.imageUrl;

        parent.window.document['mycompthis'].downloaddAndCreateNewElessonBook(bookObj, result);

        if (pageobj.enrichment_page.length > 0) {

            var bookDataObj = new BookData();

            // this.bookDataObj = new BookData();
            bookDataObj.bookDocId = bookObj._id;
            bookDataObj._id = Constants.USER + "." + bookObj.bId + ".bookData";
            bookDataObj.pages = [];
            for (var i = 0; i < pageobj.enrichment_page.length; i++) {
                var obj = pageobj.enrichment_page[i];

                var changedPageobj = this.makePageObj(obj, bookObj.bId);
                bookDataObj['' + changedPageobj.id] = changedPageobj;

                bookDataObj.pages.push(obj.id);

                if (obj.children.length > 0) {

                    this.formChildrenEle(bookDataObj['' + obj.id], obj, bookObj.bId);
                    // bookDataObj[''+obj.id].enrichment_page.push()

                }
            }
            bookDataObj.lastOpenedPage = bookDataObj.pages[0];

            this.elepouchService.addBookdataObj(bookDataObj);

            setTimeout(() => {

                document.getElementsByClassName('showDownloadloader')[0].classList.remove('ShowPdfloader');
            }, 1500);

        }
    }

    public xmlString: any
    createPurchasedNewElessonBook(bookObj, bookDataObj) {
        var self = this;
        this.pageCount = 0;
        if (localStorage.userData == 'undefined')
            var bookPath = 'assets/Nooor/Default' + '/' + bookObj.bId;
        else
            var bookPath = 'assets/Nooor/' + this.ElectronService.USER_ID + '/' + bookObj.bId;
        if (bookObj.bookType == 2) {
            var lessonPath = bookPath + '/Data/Lesson.xml';

            this.http
                .get(lessonPath)
                .subscribe(res => {

                    self.xmlString = res;
                    var xml = self.xmlString._body;
                    var result1 = JSON.parse(convert.xml2json(xml, { compact: false, spaces: 4 }));

                    for (var i = 0; i < result1.elements[0].elements.length; i++) {


                        var parentelement = result1.elements[0].elements[i];

                        var timestamp = Constants.getGUID();

                        parentelement.attributes.id = timestamp;

                        var changedPageobj = self.makeOldLiquidPageObj(parentelement.attributes, parentelement.elements, bookObj.bId);

                        bookDataObj['' + changedPageobj.id] = changedPageobj;
                        bookDataObj.pages.push(timestamp);

                        // if (i == 0) {
                        //     bookDataObj.lastOpenedPage = bookDataObj.pages[0];
                        // }

                        if (parentelement.elements) {
                            if (parentelement.elements.length > 0) {

                                self.formOldChildrenEle(parentelement.elements, bookDataObj, changedPageobj.id, bookDataObj['' + changedPageobj.id], bookObj.bId);
                            }
                        }
                    }


                    bookObj.pageCount = self.pageCount;

                    bookDataObj.lastOpenedPage = undefined;
                    self.updateLastOpenedPage(bookDataObj);


                    self.elepouchService.updateBookDataObj(bookDataObj, bookObj);
                });
        }

        else {
            var lessonPath = bookPath + '/Data/Lesson.json';
            this.http
                .get(lessonPath)
                .subscribe(res => {
                    self.jsondata = JSON.parse(res['_body']);
                    if (self.jsondata.structureJson) {
                        var nodeChildren = self.jsondata.structureJson.ELesson.Structure.node.children;

                    }

                    else {
                        var nodeChildren = self.jsondata.ELesson.Structure.node.children;

                    }
                    for (var i = 0; i < nodeChildren.length; i++) {
                        var obj = nodeChildren[i];

                        if (obj.id == undefined) {

                            obj.id = Constants.getGUID();
                        }

                        var changedPageobj = self.makeLiquidPageObj(obj, bookObj.bId);
                        bookDataObj['' + changedPageobj.id] = changedPageobj;
                        bookDataObj.pages.push(obj.id);

                        if (obj.children.length > 0) {
                            self.formPurchasedChildrenEle(bookDataObj['' + obj.id], obj, bookObj.bId);
                        }
                    }
                    bookDataObj.lastOpenedPage = bookDataObj.pages[0];
                    bookObj.pageCount = self.pageCount;
                    self.elepouchService.updateBookDataObj(bookDataObj, bookObj);
                });
        }

    }

    updateLastOpenedPage(bookDataObj) {

        var array = [];

        // Object.keys(bookDataObj).forEach(function (key) {
        //     if (bookDataObj[key].isPage) {
        //         array.push(bookDataObj[key]);


        //         // if (bookDataObj[key].description.url.length > 0) {

        //         //     bookDataObj.lastOpenedPage = key;

        //         //     return
        //         // }

        //         // else {

        //         //     if (bookDataObj[key].children.length > 0) {

        //         //         this.continueUpdatingLastOpenedPage(bookDataObj[key].children, bookDataObj)
        //         //     }
        //         // }
        //     }
        // });

        for (var key in bookDataObj) {
            if (bookDataObj[key])
                if (bookDataObj[key].isPage)
                    array.push(bookDataObj[key]);
        }


        for (var j = 0; j < array.length; j++) {

            if (bookDataObj.lastOpenedPage == undefined) {
                if (array[j].description.url.length > 0) {

                    bookDataObj.lastOpenedPage = array[j].id;

                    return
                }

                else {

                    if (array[j].children.length > 0) {

                        this.continueUpdatingLastOpenedPage(array[j].children, bookDataObj)
                    }
                }
            }

            else {

                return;
            }

        }


    }

    continueUpdatingLastOpenedPage(object, bookDataObj) {

        for (var i = 0; i < object.length; i++) {

            if (object[i].description.url.length > 0) {

                bookDataObj.lastOpenedPage = object[i].id;
                return
            }

            else {

                if (object[i].children.length > 0) {

                    this.continueUpdatingLastOpenedPage(object[i].children, bookDataObj)
                }
            }
        }

    }



    formChildrenEle(data, obj, id) {

        for (var j = 0; j < obj.children.length; j++) {
            var changedPageobj = this.makePageObj(obj.children[j], id);
            data.children.push(changedPageobj);

            if (obj.children[j].children.length > 0) {
                this.formChildrenEle(data.children[j], obj.children[j], id)
            }

        }

    }
    formPurchasedChildrenEle(data, obj, id) {
        for (var j = 0; j < obj.children.length; j++) {
            var changedPageobj = this.makeLiquidPageObj(obj.children[j], id);
            data.children.push(changedPageobj);

            if (obj.children[j].children.length > 0) {
                this.formPurchasedChildrenEle(data.children[j], obj.children[j], id)
            }

        }

    }

    makePageObj(obj, id) {

        this.pageCount++;

        var page = new Page();

        page.contentDocId = obj.contentDocId;
        page.pageNumber = this.pageCount;
        page.title = obj.title;
        page.id = obj.id;
        page.type = obj.type;
        page.description = obj.description;


        if (obj.type == "youtube") {
            page.description.url = obj.description.url;
            page.description.key = obj.description.key;
        }

        else if (obj.type == 'duplicateAsPage') {

            // if()

            if (obj.description.url.length > 0) {
                page.description.url = obj.description.url;
                page.description.key = obj.description.key;

            }


        }

        else
            page.description.url = obj.description.url;


        // updatePgae
        var timestamp = Constants.getGUID();

        var pageContent: PageContent = new PageContent();

        pageContent._id = Constants.USER + "." + timestamp + ".pageContent";

        pageContent.bookDocId = id;

        // this.pouchService.updatePageContentDoc(pageContent, obj.contentDocId);
        var self = this;
        this.elepouchService.getTemplatePageContent(obj.contentDocId).then(function (res) {
            if (res) {

                pageContent.pageContent = res['pageContent']

                self.elepouchService.createPageContentDoc(pageContent, '');

            }
        });

        page.contentDocId = pageContent._id;

        return page;


    }
    makeLiquidPageObj(obj, id) {
        if (localStorage.userData == 'undefined')
            var bookPath = 'assets/Nooor/Default' + '/' + id;
        else
            var bookPath = 'assets/Nooor/' + this.ElectronService.USER_ID + '/' + id;
        this.pageCount++;
        var page = new Page();
        page.pageNumber = this.pageCount;
        page.title = obj.title;
        page.id = obj.id;
        page.type = 'liquid';
        if (obj.media) {
            let url = obj.media.url.replace(/\\/g, "/");
            var htmlUrl = "";
            if (url.length > 0) {
                htmlUrl = bookPath + '/' + url;
            }

            this.replaceDownloadedHtmlPaths("../../../liquid_static/", "../../../../../liquid_static/", id, url);

            page.description.url = htmlUrl;
        }

        return page;
    }

    formOldChildrenEle(data, bookDataObj, id, obj, bid) {
        var self = this;
        _.forEach(data, function (childLevelEles) {

            var timestamp = Constants.getGUID();

            if (childLevelEles.attributes.Title != "") {

                childLevelEles.attributes.id = timestamp;

                var changedPageobj = self.makeOldLiquidPageObj(childLevelEles.attributes, childLevelEles.elements, bid);

                // obj.children = [];
                obj.children.push(changedPageobj);

                bookDataObj.pages.push(timestamp);

                if (childLevelEles.elements) {
                    if (childLevelEles.elements.length > 0) {

                        self.formOldChildrenEle(childLevelEles.elements, bookDataObj, changedPageobj.id, obj.children[obj.children.length - 1], bid);

                    }
                }
            }

            else {

                self.formOldChildrenEle(childLevelEles.elements, bookDataObj, id, obj, bid);
            }

        })

    }



    makeOldLiquidPageObj(obj, children, id) {
        if (localStorage.userData == 'undefined')
            var bookPath = 'assets/Nooor/Default' + '/' + id;
        else
            var bookPath = 'assets/Nooor/' + this.ElectronService.USER_ID + '/' + id;
        this.pageCount++;
        var page = new Page();
        page.pageNumber = this.pageCount;
        page.title = obj.Title;
        page.id = obj.id;
        page.type = 'liquid';
        if (obj.Url)
            if (obj.Url.length) {
                let url = obj.Url.replace(/\\/g, "/");
                var htmlUrl = bookPath + '/' + url;
                page.description.url = htmlUrl;

                this.replaceDownloadedHtmlPaths("file://///200.1.1.66/IJST/", "file:../../../../../IJST/", id, url)
            }

        return page;
    }

    replaceDownloadedHtmlPaths(existingPath, newPath, id, url) {

        var path = this.ElectronService.USER_PATH + '/' + id + '/' + url;
        var self = this;
        this.ElectronService.FS.readFile(path, "utf-8", (err, data) => {

            if (err) {
                console.log("cannot read file", err);
                return;
            }
            // console.log("Content:");

            var htmlContent = data;

            // console.log("htmlContent" + htmlContent + "printed");


            htmlContent = _.replace(htmlContent, new RegExp(existingPath, "g"), newPath)


            console.log("htmlContent" + htmlContent + "replaced");


            self.ElectronService.FS.writeFile(path, htmlContent, (err) => {
                if (err) {
                    alert("An error ocurred updating the file" + err.message);
                    console.log(err);
                    return;
                }

                console.log("htmlContent" + htmlContent + "replaced");

                // alert("The file has been succesfully saved");
            });
        });
    }


}



// WEBPACK FOOTER //
// ./src/app/bookShared/downloadELE.service.ts